<script>
  import { emitter } from '@/main.js';
  export default {
    name: 'PDPPriceBlock',
    data() {
      return {
        currentPrice: '',
        comparePrice: '',
        currentPriceNumber: '',
        comparePriceNumber: '',
        countryCode: '',
        currencyCode: '',
        showPercentage: false,
        isFinalSale: false,
        isOutfitPicker: false,
        currentVariantPrice: '',
        final_sale_tag: 'final-sale',
        localProductId: null,
        localProductHandle: null,
        priceBlockIndex: null,
        showOriginalOnSalePrice: false
      };
    },
    computed: {
      percentage: function () {
        return this.handlePercentage();
      }
    },
    mounted() {
      this.canadaFinalSale = window.canadaFinalSale;
      this.countryCode = window.Shopify.country;
      this.showCanadaFinalSale = this.canadaFinalSale && this.countryCode === 'CA';
      this.currencyCode = window.Shopify.currency.active;
      this.showPercentage = this.$el.parentElement.dataset.showPercentage;
      this.isFinalSale = this.$el.parentElement.dataset.finalSale === 'true';
      this.localProductId = this.$el.parentElement.dataset.productId;
      this.localProductHandle = this.$el.parentElement.dataset.productHandle;
      this.isOutfitPicker = this.$el.parentElement.dataset.isOutfitPicker === 'true';
      if (this.isOutfitPicker) {
        this.priceBlockIndex = Number(this.$el.parentElement.dataset.outfitPickerPriceBlockIndex);
      }
      this.showOriginalOnSalePrice = this.$el.parentElement.dataset.showOriginalOnSalePrice === 'true';

      emitter.on('pdp-color-updated', e => {
        if (e.pid) {
          window.dispatchEvent(
            new CustomEvent('authentic:membership-parent-id-change', {
              bubbles: true,
              detail: {
                pid: e.pid
              }
            })
          );
        }
      });

      emitter.on('pdp-tags-updated', e => {
        const tags = e.tags;
        this.isFinalSale = false;
        this.isFinalSale = tags.includes(this.final_sale_tag);
      });

      emitter.on('updateAddButton', e => {
        if (this.isOutfitPicker) return;
        const normalizeId = val => (val ? String(val).replace(/\D+/g, '') : '');
        const idMatch = normalizeId(e.parentId) && normalizeId(this.localProductId) && normalizeId(e.parentId) === normalizeId(this.localProductId);
        const handleMatch = e.handle && this.localProductHandle && String(e.handle) === String(this.localProductHandle);
        if (!idMatch && !handleMatch) return;
        if (e.variantPrice !== this.currentVariantPrice) {
          window.dispatchEvent(
            new CustomEvent('authentic:variant-price-change', {
              bubbles: true,
              detail: {
                variantPrice: e.variantPrice
              }
            })
          );
        }
        this.currentVariantPrice = e.variantPrice;
        this.currentPrice = this.convertToCurrency(e.variantPrice);
        this.comparePrice = this.convertToCurrency(e.comparePrice);
        this.currentPriceNumber = parseFloat(e.variantPrice) || 0;
        this.comparePriceNumber = parseFloat(e.comparePrice) || 0;
      });

      emitter.on('updatePriceBlock', e => {
        if (e.isOutfitPicker !== this.isOutfitPicker) return;
        if (this.isOutfitPicker && e.blockIndex !== this.priceBlockIndex) return;

        this.currentVariantPrice = e.variantPrice;
        this.currentPrice = this.convertToCurrency(e.variantPrice);
        this.comparePrice = this.convertToCurrency(e.comparePrice);
        this.currentPriceNumber = parseFloat(e.variantPrice) || 0;
        this.comparePriceNumber = parseFloat(e.comparePrice) || 0;
      });
    },
    methods: {
      handlePercentage() {
        if (this.currentPriceNumber && this.currentPriceNumber && this.showPercentage == 'true' && this.comparePriceNumber != '') {
          if (isFinite(Math.round(((this.comparePriceNumber - this.currentPriceNumber) / this.comparePriceNumber) * 100))) {
            return Math.round(((this.comparePriceNumber - this.currentPriceNumber) / this.comparePriceNumber) * 100);
          }
          return '';
        } else {
          return '';
        }
      },
      checkClass() {
        if (this.comparePriceNumber > 0 && this.comparePriceNumber > this.currentPriceNumber) {
          return 'product__price--sale';
        } else {
          return '';
        }
      },
      convertToCurrency(str) {
        let dollarUS = Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: this.currencyCode
        });

        let price = dollarUS.format(str).replace('.00', '');

        if (price.includes('CA')) {
          price = price.replace('CA', '');
          price = price + ' CAD';
        }
        if (!isNaN(str)) {
          return price;
        } else {
          return '';
        }
      }
    }
  };
</script>

<template>
  <div class="pdp-price-block">
    <div>
      <span data-product-price :class="checkClass()" v-html="currentPrice"></span>
      <span class="pdp-sale markdown" data-price-sale-amount v-html="comparePrice" v-if="comparePriceNumber > 0 && comparePriceNumber > currentPriceNumber"></span>
      <span class="gt-p__small--x on-sale percentage" v-html="'(' + percentage + '% off)'" v-if="percentage != '' && percentage > 0"></span>
    </div>

    <span v-if="countryCode === 'CA' && canadaFinalSale" class="final-sale" v-html="canadaFinalSale"></span>
    <span v-if="(isFinalSale && countryCode !== 'CA') || (isFinalSale && countryCode == 'CA' && !canadaFinalSale)" class="final-sale">Final Sale</span>
  </div>
</template>

<style lang="scss">
  .PDPPriceBlock {
    .product__price--sale {
      margin-right: 3px;
    }

    .percentage.on-sale {
      margin-left: 3px;
    }
  }

  .pdp-price-block {
    display: flex;
    flex-direction: column;
  }
</style>
